import React from 'react';
import tape from '../Assets/tape.svg';

const Display = (props) => {

    const styles = {
        opacity: '1'
    }
    let display;

    if ( props.isOff ){
        display = '\xa0';
    } else{
        display = props.output;
    }

    if ( props.output === 'OFF w/o Tape' || props.output === 'ON w/o Tape'){
        styles.opacity = '0.1';
    }

    return(
        
        <div id="Display">
            <div className="Display__message">
               {display}
            </div>
            <div className="Display__message--caption">
                State
            </div>
            <div className="Display__tape" style={styles}>
                <img src={tape} alt=""/>
            </div>
            <div className="Display__message--caption">
                Tape
            </div>
        </div>
    );
}

export default Display;


// WEBPACK FOOTER //
// ./src/Display/Display.js